import React from 'react';
import { formControlPropTypes } from '@App/common/components/FormControl/FormControlPropTypes';
import FormControlCommon from '@App/common/components/FormControl/FormControl';
import * as styles from './FormControl.module.scss';
const FormControl = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FormControlCommon, Object.assign({}, props, {
  classname: `${styles.root} ${(props === null || props === void 0 ? void 0 : props.classname) || null}`,
  ref: ref
})));
FormControl.propTypes = formControlPropTypes;
export default FormControl;